<div>
  <ng-container *ngIf="!isLoading; else loadingContent">
    <ng-container *ngIf="!hasError; else errorContent">
      <h3>{{mpContent?.heading}}</h3>
      <hr>
      <div>
        @if (mpContent?.body) {
          <div [innerHtml]="mpContent?.body"></div>
        }
        @else {
          <div>No details to show at this time.</div>
        }
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- Error Content -->
<ng-template #errorContent>
  <p>There was an unexpected error. Please refresh the page or try again later.</p>
</ng-template>

<!-- Loading Content -->
<ng-template #loadingContent>
  <app-pol-loader skeletonSize="large" [skeletonRows]="4" skeletonAlignment="aligned"></app-pol-loader>
</ng-template>
